export const API_BASE = '/get_list?list_name=';

export const API_CLIENT = 'client';

export const API_LOGO = `/site_info`;

export const API_NAVIGATION = 'right navigation';

export const API_LEVEL_ONE = 'Level One';
export const API_LEVEL_TWO = 'Level Two';
export const API_LEVEL_THREE = 'Level Three';
export const API_LEVEL_FOUR = 'Level Four';

export const API_DOCUMENTS = '/lookup_workingdocuments';

/**
 * Browse specific item of SharePoint List
 * @param {string} list The list name in SharePoint
 * @param {string} id The id of the item to be extracted
 * @returns The parameterized API route.
 */
export const API_GET_LIST_BY_ID = (list, id) =>
  `/get_list_by_id?list_name=${list}&id=${id}`;

/**
 * Get the metadata of a specific document
 * @param {string} slug The slug of the document to be extracted
 * @returns The parameterized API route.
 */
export const API_DOCUMENT_BY_SLUG = (slug) =>
  `/get_documents_by_slug?slug=${slug}`;

/**
 * Get the metadata of a specific document
 * @param {string} id The id of the document to be extracted
 * @returns The specified document metadata
 */
export const API_DOCUMENT_BY_ID = (id) =>
  `/get_list_by_document_id?list_name=Working Documents&doc_id=${id}`;

/**
 * Check if a document has previous Versions
 * @param {string} id The id of the document to be checked
 * @returns The specified document list of versions
 */
export const API_DOCUMENT_BY_NEW_VERSION_ID = (id) =>
  `/get_list_by_new_version_id?list_name=Working%20Documents&new_version_id=${id}`;

export const API_PAGES = '/lookup_webpageinfo';

/**
 * Returns pages metadata for a specific document
 * @param {string} docID The document to be populated with pages
 * @returns The document pages
 */
export const API_PAGES_BY_DOC = (docID) =>
  `/get_list_by_document_id?list_name=web page info&doc_id=${docID}`;

export const API_RELATED_DOCUMENT = '/get_related_documents?doc_id=';
export const API_RELATED_SECTION = '/get_related_section?page_id=';

export const API_RELATED_CONTENT = 'related content';
export const API_RELATED_CONTENT_RELATIONSHIP = 'related content relationship';

export const API_GLOSSARY = 'glossary';
export const API_GLOSSARY_RELATIONSHIP = 'glossary relationship';

export const API_SEARCH = '/search';

export const INTERNAL_ERROR =
  'Internal error, please check your connection and try again.';

export const AUTHENTICATE = '/Account/authenticate';

export const LOG_OUT_API = '/Account/revoke-token';

export const REFRESH_TOKEN_API = `/Account/refresh-token`;

export const ACTIVATE_PRODUCT_API = `/Account/activate-product`;

export const UPDATE_USER_API = (id) => `/Account/update-user/${id}`;

export const CHANGE_PASSWORD_API = `/Account/change-password`;

export const CHANGE_SELECTED_PLAN_API = `/Account/change-selected-plan`;

export const REGISTER = '/Account/register';
/**
 * Endpoint to resend confirmation email
 * @param {string} userId
 * @returns Parameterized confirmation email endpoint
 */
export const RESEND_EMAIL_API = (userId) =>
  `/Account/resend-confirm-email?userId=${userId}`;
export const FORGOT_PASSWORD = '/Account/forgot-password';
export const RESET_PASSWORD = '/Account/reset-password';
export const GET_PLANS = '/v1/Plan';
export const CANCEL_REASON_API = `/v1/Unsubscribe`;

/**
 * Confirm user exists via their email address
 * @param {string} userId The user to be confirmed
 * @param {string} code The one time generated code
 * @returns The parameterised endpoint.
 */
export const CONFIRM_EMAIL = (userId, code) =>
  `/Account/confirm-email/?userId=${userId}&code=${code}`;

export const CREATE_BOOKMARK_API = '/v1/Bookmark';

/**
 * Get bookmarks by user ID
 * @param {string} userId The user to  have the bookmarks filtered
 * @returns The parameterised endpoint.
 */
export const GET_USER_BOOKMARKS = (userId) =>
  `/v1/Bookmark/GetByUserId/${userId}`;

/**
 * Get bookmarks by user ID
 * @param {string} bookmarkID The user to  have the bookmarks filtered
 * @returns The parameterised endpoint.
 */
export const DELETE_BOOKMARK_API = (bookmarkID) => `/v1/Bookmark/${bookmarkID}`;

export const DELETE_BOOKMARKS_API = `/v1/Bookmark/DeleteBulkByIds`;

export const CREATE_COMMENT_API = `/v1/Comment`;

export const INVITE_USER_API = `/Account/invite`;

export const GET_USERS_BY_CLIENT_ID_API = (clientId) =>
  `/Account/client-users?clientId=${clientId}`;

export const DELETE_USER_CLIENT_API = (clientId, userId) =>
  `/Account/delete-client-user?clientId=${clientId}&userId=${userId}`;

export const UPDATE_CLIENT_ROLE_API = `/Account/assign-client-role`;

export const REINVITE_USER_API = `/Account/re-invite`;

export const SEND_ENQUIRY_API = '/v1/Enquiry';

export const API_GET_DOC_SUMMARY = (id) =>
  `/get_summary_by_document_id?doc_id=${id}`;

export const CREATE_PAYMENT_METHOD_API =
  '/v1/Payment/createPaymentMethodSession';

export const UPDATE_CLIENT_API = (id) => `/v1/Client/${id}`;

export const CREATE_CLIENT_SUBSCRIPTION_API = '/v1/Subscription';
export const UPDATE_CLIENT_SUBSCRIPTION_API = (id) => `/v1/Subscription/${id}`;

export const USAGE_BY_USER_ID_API = (userId) =>
  `/v1/Usage/GetByUserId/${userId}`;
export const UPDATE_USER_USAGE_API = '/v1/Usage';

// Developer-API usage report for the authenticated caller (per-day counts + totals).
export const API_USAGE_MY = (year, month) =>
  `/v1/ApiUsage/my?year=${year}&month=${month}`;

// Developer-API key management (all scoped to the authenticated caller server-side).
export const API_KEYS_MY = '/v1/ApiKey/my';
export const CREATE_API_KEY = '/v1/ApiKey/CreateAPIKey';
export const REVOKE_API_KEY = (id) => `/v1/ApiKey/${id}/revoke`;

export const GET_QUERY_BY_USER_ID_API = (userId) =>
  `/v1/Query/GetByUserId/${userId}`;

export const GET_QUERY_MESSAGES_BY_QUERY_ID_API = (queryId) =>
  `/v1/QueryMessage/GetByQueryId/${queryId}`;

export const CREATE_NEW_QUERY_API = '/v1/Query';

export const UPDATE_QUERY_API = (queryId) => `/v1/Query/${queryId}`;

export const DELETE_QUERY_API = (queryId) => `/v1/Query/${queryId}`;

export const CREATE_NEW_MESSAGE_API = '/v1/QueryMessage';

export const UPDATE_MESSAGES_RESPONSE_API = (messageId) => `/v1/QueryMessage/${messageId}`;

export const BUY_ADDITIONAL_QUERIES_API = '/v1/Client/CreateAdditionalPurchase';

// const res = await fetch({
//   method: "POST",
//   baseURL: AUTH_BASE,
//   url: AUTHENTICATE,
//   data: JSON.stringify({
//     email: userName,
//     password: password
//   }),
//   headers: {
//     'Content-Type': 'application/json'
//   }
// });
